<div class="form-response-editor p-2">
	<h3 class="my-2">{{label || 'Capturar formulario'}}: {{response_info.form?.title}}</h3>
	<app-loading [is_loading]="is_loading"></app-loading>
	<div *ngIf="!is_loading">
		<div *ngIf="response_info.form?.is_response_title_required == 1" class="my-2">
			<label class="fw-bold">Título de la respuesta</label>
			<input type="text" name="response_title" [(ngModel)]="response_info.response.title" class="form-control" placeholder="Titulo de la respuesta">
		</div>
		<div *ngFor="let ai of response_info.answers; let i = index" class="my-2">
			<label class="fw-bold">
				{{ai.question.question}}<span *ngIf="ai.question.required == 1" class="text-danger"> *</span>
			</label>
			<label *ngIf="ai.question.help" class="d-block text-muted fst-italic">{{ai.question.help}}</label>
			<textarea *ngIf="ai.question.type == 'textarea'" [name]="'answer'+i" [(ngModel)]="ai.answer.answer_text" class="form-control" rows="2" [required]="ai.question.required == 1"></textarea>
			<input *ngIf="ai.question.type != 'textarea'" [type]="getInputType(ai.question.type)" [name]="'answer'+i" [(ngModel)]="ai.answer.answer_text" class="form-control" [required]="ai.question.required == 1">
		</div>
		<div *ngIf="response_info.answers.length == 0" class="text-muted my-2">Este formulario no tiene preguntas</div>
		<div class="text-end my-3">
			<button type="button" class="btn btn-primary" (click)="accept()">Aceptar</button>
		</div>
	</div>
</div>
